import { Dispatch, SetStateAction } from 'react';

export type ID = undefined | null | number;

export type PaginationState = {
  page: number;
  limit: 10 | 15 | 30 | 50 | 100;
  links?: Array<{
    label: string;
    active: boolean;
    url: string | null;
    page: number | null;
  }>;
};

export type SortState = {
  sort?: string;
  order?: 'asc' | 'desc';
  apiSort?: string;
  apiOrder?: 'asc' | 'desc';
  sortSummaryReport?: string;
  orderSummaryReport?: 'asc' | 'desc';
};

export type FilterState = {
  filter?: unknown;
};

export type SearchState = {
  newVersion?: string;
  isDuriooCreator?: string;
  duDeen?: string;
  q?: string;
};

export type Response<T> = {
  data?: T;
  payload?: {
    message?: string;
    errors?: {
      [key: string]: Array<string>;
    };
    pagination?: PaginationState;
  };
};

export type QueryState = PaginationState &
  SortState &
  FilterState &
  SearchState;

export type QueryRequestContextProps = {
  state: QueryState;
  updateState: (updates: Partial<QueryState>) => void;
};

export const initialQueryState: QueryState = {
  page: 1,
  limit: 100,
};

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
};

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined;
  refetch: () => void;
  isLoading: boolean;
  query: string;
};

export const initialQueryResponse = {
  refetch: () => {},
  isLoading: false,
  query: '',
};

export type ListViewContextProps = {
  selected: Array<ID>;
  onSelectOne?: any;
  onSelect: (selectedId: ID) => void;
  onSelectAll: () => void;
  clearSelected: () => void;
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID;
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>;
  isAllSelected: boolean;
  isAllSelectedVideoCollection?: boolean;
  disabled: boolean;
  onSelectAllVideoCollection?: () => void;
};

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelectOne: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
  onSelectAllVideoCollection: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  isAllSelectedVideoCollection: false,
  disabled: false,
};
